import { Circle } from 'lucide-react';
import { forwardRef } from 'react';
import { DeckardIcon, DeckardIconProps } from './DeckardIcon';

export const CircleIcon: DeckardIcon = forwardRef<SVGSVGElement, DeckardIconProps>(
  ({ circle, color = 'currentColor', double, ...props }, ref) => (
    <Circle ref={ref} className="deckard-icon" fill={color} color={color} {...props} />
  ),
);
